var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeart = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 20,
  viewBox: "0 0 19 20",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.81 6.905c0-3.385-1.8-5.357-4.715-5.357-1.554 0-2.592.606-3.198 1.847a.519.519 0 0 1-.937 0c-.606-1.24-1.644-1.847-3.198-1.847-2.915 0-4.714 1.972-4.714 5.357 0 2.57 2.774 5.785 8.38 9.54 5.607-3.755 8.382-6.97 8.382-9.54zM13.095.477c3.51 0 5.762 2.467 5.762 6.428 0 3.1-3.068 6.608-9.144 10.629a.514.514 0 0 1-.569 0C3.068 13.513 0 10.006 0 6.905 0 2.944 2.252.477 5.762.477c1.6 0 2.839.56 3.667 1.666.828-1.106 2.066-1.666 3.666-1.666z",
  fillRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
export default ForwardRef;